import { AppContextsSubscriptionApi } from 'services/ApiService';
import { logError } from 'services/logger';
import { useQuery } from '@tanstack/react-query';
import { sgConnect } from 'services/SgConnect';

const APP_CONTEXT_QUERIES_KEY = 'appContextSubscriptionQueries';

const keys = {
    getAppContext: () => [APP_CONTEXT_QUERIES_KEY, 'getAppContext'],
};

export const useGetAppContextSubscription = () => {
    const getAppContext = async () => {
        try {
            return await AppContextsSubscriptionApi.get();
        }
        catch (error) {
            logError(error);
            throw error;
        }
    };

    const isAuthorized = sgConnect?.isAuthorized() ?? false;
    return useQuery({
        queryKey: keys.getAppContext(),
        queryFn: () => getAppContext(),
        enabled: isAuthorized,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
